export default [
  {
    key: '1',
    type: {
      title: 'SMS-сообщение',
      description: '+7 (920) 000-00-00',
    },
    date_send: '1567077828822',
    info: {
      text: 'ООО «Колышек» Заказ 122 352 180 319 000 112 312 312 312',
      description: '',
    },
  },
  {
    key: '2',
    type: {
      title: 'Письмо на e-mail',
      description: 'ivanov@ivanov.ru',
    },
    date_send: '1567077828822',
    info: {
      text: 'Договор об оказании услуги',
      description: 'Вложений: 6',
    },
  },
  {
    key: '3',
    type: {
      title: 'SMS-сообщение',
      description: '+7 (920) 000-00-00',
    },
    date_send: '1567077828822',
    info: {
      text: 'ООО «Колышек» Заказ 122 352 180 319 000 112 312 312 312',
      description: '',
    },
  },
  {
    key: '4',
    type: {
      title: 'Письмо на e-mail',
      description: 'ivanov@ivanov.ru',
    },
    date_send: '1567077828822',
    info: {
      text: 'Договор об оказании услуги',
      description: 'Вложений: 6',
    },
  },
];
